import { render, staticRenderFns } from "./ques-radio.vue?vue&type=template&id=945c7e8a&scoped=true"
import script from "./ques-radio.vue?vue&type=script&lang=js"
export * from "./ques-radio.vue?vue&type=script&lang=js"
import style0 from "./ques-radio.vue?vue&type=style&index=0&id=945c7e8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945c7e8a",
  null
  
)

export default component.exports